/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { moneyFormatter } from '../../../utils';
import { getRequisicaoPedidosAlmoxarifado } from './statusLabels';

const pedidoHref = (pedido) => {
  const id = pedido?.id;
  if (!id) return null;
  return `/v2/estoque/pedidos?id=${encodeURIComponent(id)}&p=0&s=10`;
};

const produtoLinha = (pedido) => {
  const produtos = pedido.produtos || [];
  if (produtos.length) {
    return produtos
      .map((linha) => {
        const nome = linha.produtoNome || linha.nome || 'Produto';
        const qtd = linha.quantidade != null ? ` · ${linha.quantidade} un.` : '';
        return `${nome}${qtd}`;
      })
      .join(' · ');
  }
  if (pedido.produtoNome) {
    const qtd = pedido.quantidade != null ? ` · ${pedido.quantidade} un.` : '';
    return `${pedido.produtoNome}${qtd}`;
  }
  return null;
};

const PedidosTab = ({ requisicao }) => {
  const pedidos = getRequisicaoPedidosAlmoxarifado(requisicao);
  if (!pedidos.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        Nenhum pedido de almoxarifado. Aprovar gera saída; Para pedido gera entrada.
        Os dois aparecem aqui, já ligados ao item.
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      {pedidos.map((pedido) => {
        const href = pedidoHref(pedido);
        const produto = produtoLinha(pedido);
        const isSaida = pedido.tipoPedido === 'SAIDA';
        const totalRaw = isSaida
          ? null
          : pedido.valorTotal != null
            ? pedido.valorTotal
            : (pedido.produtos || []).reduce((sum, linha) => sum + (Number(linha.valorTotal) || 0), 0);
        const totalLabel = totalRaw
          ? (typeof totalRaw === 'number' ? moneyFormatter(totalRaw) : String(totalRaw))
          : null;
        return (
          <Box
            key={`${pedido.tipoPedido}-${pedido.id}`}
            sx={{
              border: 1,
              borderColor: 'divider',
              borderRadius: 1,
              p: 2,
            }}
          >
            <Stack spacing={0.75}>
              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
                <Chip
                  size="small"
                  label={isSaida ? 'Saída' : 'Entrada'}
                  sx={{ height: 20, '& .MuiChip-label': { px: 0.75 } }}
                />
                {pedido.numero ? (
                  <Typography variant="caption" color="text.secondary">
                    {pedido.numero}
                  </Typography>
                ) : null}
                {href ? (
                  <Button
                    size="small"
                    variant="text"
                    component="a"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    endIcon={<OpenInNewIcon fontSize="small" />}
                    sx={{ px: 0.5, minWidth: 0, '& .MuiButton-endIcon': { ml: 0.5 } }}
                  >
                    Visualizar
                  </Button>
                ) : null}
              </Stack>
              {produto ? (
                <Typography variant="body2">{produto}</Typography>
              ) : (
                <Typography variant="body2">
                  {isSaida ? 'Pedido de saída' : 'Pedido de entrada'}
                </Typography>
              )}
              {pedido.local ? (
                <Typography variant="caption" color="text.secondary">
                  Local {pedido.local}
                </Typography>
              ) : null}
              {!isSaida && pedido.fornecedor ? (
                <Typography variant="caption" color="text.secondary">
                  Fornecedor {pedido.fornecedor}
                </Typography>
              ) : null}
              {!isSaida ? (
                <Typography variant="caption" color="text.secondary">
                  Devolução de uso: Não
                </Typography>
              ) : null}
              {totalLabel ? (
                <Typography variant="body2">
                  Total {totalLabel}
                </Typography>
              ) : null}
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
};

PedidosTab.propTypes = {
  requisicao: PropTypes.object,
};

PedidosTab.defaultProps = {
  requisicao: {},
};

export default PedidosTab;
